module.exports = __webpack_public_path__ + "static/media/close-icon.650fb47d.svg";